import {
  HOME_CREATE_SCHEDULE_BEGIN,
  HOME_CREATE_SCHEDULE_SUCCESS,
  HOME_CREATE_SCHEDULE_FAILURE,
  HOME_CREATE_SCHEDULE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import {setSelectedSchedule} from './setSelectedSchedule'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function createSchedule(seasonId) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CREATE_SCHEDULE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post("/api/schedules/"+seasonId).then(
        (res) => {
          dispatch({
            type: HOME_CREATE_SCHEDULE_SUCCESS,
            data: res.data,
          });
          dispatch(setSelectedSchedule("main",res.data.id));
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CREATE_SCHEDULE_FAILURE,
            data: { error: err },
          });
          resolve(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCreateScheduleError() {
  return {
    type: HOME_CREATE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CREATE_SCHEDULE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createSchedulePending: true,
        createScheduleError: null,
      };

    case HOME_CREATE_SCHEDULE_SUCCESS:
      // The request is success
      return {
        ...state,
        createSchedulePending: false,
        createScheduleError: null,
        schedules:
        {
          ...state.schedules,
          [action.data.id]: action.data
        },

          
      };

    case HOME_CREATE_SCHEDULE_FAILURE:
      // The request is failed
      return {
        ...state,
        createSchedulePending: false,
        createScheduleError: action.data.error,
      };

    case HOME_CREATE_SCHEDULE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createScheduleError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/createSchedule.js